module.exports = __webpack_public_path__ + "img/b.5e21de89.png";